/* DRIP LADY Quick View Modal v3 */
(function () {
  'use strict';
  if (window.__dl_qv_loaded) return;
  window.__dl_qv_loaded = true;

  var MATCH_SELECTORS = ['.discover-btn', '.atc-bouton', '.dl-quickview-trigger', '[data-product-handle]'];
  var state = { modal:null, backdrop:null, card:null, currentProduct:null, currentVariant:null, selectedOptions:{}, isOpen:false, isFetching:false };

  function log() { try { console.log.apply(console, ['[DL-QV]'].concat([].slice.call(arguments))); } catch(e){} }
  function warn() { try { console.warn.apply(console, ['[DL-QV]'].concat([].slice.call(arguments))); } catch(e){} }
  function err() { try { console.error.apply(console, ['[DL-QV]'].concat([].slice.call(arguments))); } catch(e){} }

  function matchesAny(el, sels) {
    if (!el || el.nodeType !== 1) return null;
    for (var i=0; i<sels.length; i++) { try { if (el.matches && el.matches(sels[i])) return el; } catch(e){} }
    return null;
  }

  function findTriggerFromEvent(e) {
    var path = e.composedPath ? e.composedPath() : null;
    if (path) {
      for (var i=0; i<path.length; i++) {
        var node = path[i];
        if (!node || node.nodeType !== 1) continue;
        var hit = matchesAny(node, MATCH_SELECTORS);
        if (hit) return hit;
        if (node.tagName === 'BUTTON' && node.getAttribute('name') === 'add') {
          var c = node.closest('.product-card, .dl-card, .product-single, [data-product-handle]');
          if (c) return node;
        }
      }
      return null;
    }
    var t = e.target; var depth = 0;
    while (t && depth < 15) {
      var h = matchesAny(t, MATCH_SELECTORS);
      if (h) return h;
      if (t.tagName === 'BUTTON' && t.getAttribute('name') === 'add') {
        var cc = t.closest && t.closest('.product-card, .dl-card, .product-single, [data-product-handle]');
        if (cc) return t;
      }
      t = t.parentNode; depth++;
    }
    return null;
  }

  function extractHandleFromHref(href) {
    if (!href) return null;
    var m = href.match(/\/products\/([a-z0-9\-_]+)/i);
    return m ? m[1] : null;
  }

  function extractHandle(el) {
    if (!el) return null;
    var node = el, depth = 0;
    while (node && depth < 12) {
      if (node.getAttribute && node.getAttribute('data-product-handle')) return node.getAttribute('data-product-handle');
      node = node.parentNode; depth++;
    }
    if (el.tagName === 'A' && el.getAttribute('href')) {
      var h = extractHandleFromHref(el.getAttribute('href'));
      if (h) return h;
    }
    node = el; depth = 0;
    while (node && depth < 10) {
      if (node.tagName === 'A' && node.getAttribute && node.getAttribute('href')) {
        var hh = extractHandleFromHref(node.getAttribute('href'));
        if (hh) return hh;
      }
      node = node.parentNode; depth++;
    }
    node = el; depth = 0;
    while (node && depth < 10) {
      if (node.querySelector) {
        var link = node.querySelector('a[href*="/products/"]');
        if (link) { var hhh = extractHandleFromHref(link.getAttribute('href')); if (hhh) return hhh; }
      }
      node = node.parentNode; depth++;
    }
    return null;
  }

  function onIntercept(e) {
    if (state.isOpen) return;
    var btn = findTriggerFromEvent(e);
    if (!btn) return;
    log('event', e.type, 'target:', e.target.tagName, (e.target.className || '').slice(0,60));
    var handle = extractHandle(btn);
    if (!handle) { warn('no handle extracted from', btn); return; }
    e.preventDefault(); e.stopImmediatePropagation();
    log('intercept fired, handle:', handle);
    if (e.type === 'click' || e.type === 'touchstart') openModal(handle);
  }

  function neutralizeSubmit(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var btns = scope.querySelectorAll('.product-single__form .atc-bouton');
    for (var i=0; i<btns.length; i++) {
      if (btns[i].getAttribute('type') !== 'button') btns[i].setAttribute('type', 'button');
    }
  }

  function injectStyles() {
    if (document.getElementById('dl-qv-styles')) return;
    var css = '.dl-qv-backdrop{position:fixed;inset:0;background:rgba(0,0,0,.65);z-index:99999;opacity:0;transition:opacity .25s ease;display:flex;align-items:center;justify-content:center;padding:20px;backdrop-filter:blur(6px)}.dl-qv-backdrop.dl-qv-open{opacity:1}.dl-qv-card{background:#fff;border-radius:24px;padding:28px;max-width:560px;width:100%;max-height:90vh;overflow:auto;position:relative;transform:scale(.94);opacity:0;transition:transform .28s cubic-bezier(.2,.8,.25,1),opacity .28s ease;font-family:Inter,system-ui,sans-serif;color:#0A0A0A}.dl-qv-backdrop.dl-qv-open .dl-qv-card{transform:scale(1);opacity:1}.dl-qv-close{position:absolute;top:14px;right:14px;width:36px;height:36px;border-radius:50%;background:rgba(10,10,10,.06);border:0;cursor:pointer;font-size:20px;line-height:1;display:flex;align-items:center;justify-content:center}.dl-qv-close:hover{background:#0A0A0A;color:#fff;transform:rotate(90deg);transition:all .25s}.dl-qv-loading{padding:60px 0;text-align:center;font-family:"JetBrains Mono",monospace;font-size:13px;letter-spacing:.05em;color:rgba(10,10,10,.6)}.dl-qv-top{display:flex;gap:18px;align-items:flex-start;margin-bottom:24px}.dl-qv-img{width:140px;height:140px;object-fit:cover;border-radius:12px;flex-shrink:0;background:#f4f4f4}.dl-qv-meta{flex:1;min-width:0}.dl-qv-vendor{font-family:Inter,sans-serif;font-size:12px;text-transform:uppercase;letter-spacing:.12em;color:rgba(10,10,10,.55);margin-bottom:6px}.dl-qv-title{font-family:"Bricolage Grotesque",serif;font-style:italic;font-size:22px;line-height:1.2;margin:0 0 10px;color:#0A0A0A}.dl-qv-price{font-family:"JetBrains Mono",monospace;font-size:24px;font-weight:600;color:#E91E80}.dl-qv-options{margin-bottom:22px}.dl-qv-option{margin-bottom:14px}.dl-qv-option-label{font-family:"JetBrains Mono",monospace;font-size:11px;text-transform:uppercase;letter-spacing:.1em;color:rgba(10,10,10,.65);margin-bottom:8px;display:block}.dl-qv-pills{display:flex;flex-wrap:wrap;gap:8px}.dl-qv-pill{padding:8px 16px;border:1.5px solid #0A0A0A;background:transparent;border-radius:999px;font-family:Inter,sans-serif;font-size:13px;cursor:pointer;color:#0A0A0A;transition:background .18s,color .18s}.dl-qv-pill:hover{background:rgba(10,10,10,.06)}.dl-qv-pill.dl-qv-active{background:#E91E80;color:#fff;border-color:#E91E80}.dl-qv-pill[disabled]{opacity:.35;cursor:not-allowed;text-decoration:line-through}.dl-qv-cta{width:100%;padding:16px 22px;border:0;background:#E91E80;color:#fff;border-radius:999px;font-family:Inter,sans-serif;font-weight:600;font-size:14px;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;transition:background .22s,box-shadow .22s,transform .22s}.dl-qv-cta:hover{background:#0A0A0A;box-shadow:0 8px 28px rgba(233,30,128,.35);transform:translateY(-1px)}.dl-qv-cta[disabled]{background:rgba(10,10,10,.25);cursor:not-allowed;box-shadow:none;transform:none}.dl-qv-msg{min-height:20px;margin-top:12px;text-align:center;font-family:"JetBrains Mono",monospace;font-size:12px}.dl-qv-msg.ok{color:#1f8a3b}.dl-qv-msg.err{color:#c0392b}.dl-qv-fly{position:fixed;border-radius:12px;object-fit:cover;z-index:100000;pointer-events:none;transition:transform .85s cubic-bezier(.5,.05,.4,1),opacity .85s ease,width .85s ease,height .85s ease}@media (prefers-reduced-motion:reduce){.dl-qv-backdrop,.dl-qv-card,.dl-qv-fly,.dl-qv-cta,.dl-qv-pill{transition:none!important}}@media (max-width:520px){.dl-qv-top{flex-direction:column}.dl-qv-img{width:100%;height:220px}}';
    var style = document.createElement('style');
    style.id = 'dl-qv-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function buildModal() {
    if (state.modal) return;
    injectStyles();
    var backdrop = document.createElement('div');
    backdrop.className = 'dl-qv-backdrop';
    backdrop.setAttribute('role', 'dialog');
    backdrop.setAttribute('aria-modal', 'true');
    var card = document.createElement('div');
    card.className = 'dl-qv-card';
    var close = document.createElement('button');
    close.className = 'dl-qv-close';
    close.setAttribute('aria-label', 'Fermer');
    close.innerHTML = '&times;';
    close.addEventListener('click', closeModal);
    card.appendChild(close);
    backdrop.appendChild(card);
    backdrop.addEventListener('click', function(e) { if (e.target === backdrop) closeModal(); });
    document.body.appendChild(backdrop);
    state.modal = backdrop; state.backdrop = backdrop; state.card = card;
  }

  function setCardBody(html) {
    var close = state.card.querySelector('.dl-qv-close');
    state.card.innerHTML = '';
    state.card.appendChild(close);
    var w = document.createElement('div');
    w.innerHTML = html;
    while (w.firstChild) state.card.appendChild(w.firstChild);
  }

  function showLoading() { setCardBody('<div class="dl-qv-loading">Chargement…</div>'); }
  function formatMoney(c) { return (c/100).toFixed(2).replace('.', ',') + ' €'; }

  function renderProduct(product) {
    state.currentProduct = product;
    state.selectedOptions = {};
    var hasOptions = product.options && product.options.length && !(product.options.length === 1 && product.options[0] === 'Title');
    var firstAvail = null;
    for (var i=0; i<product.variants.length; i++) if (product.variants[i].available) { firstAvail = product.variants[i]; break; }
    var initVariant = firstAvail || product.variants[0];
    if (initVariant && product.options) {
      for (var o=0; o<product.options.length; o++) state.selectedOptions[product.options[o]] = initVariant['option'+(o+1)];
    }
    state.currentVariant = initVariant;
    var img = product.featured_image || (product.images && product.images[0]) || '';
    var vendor = product.vendor || '';
    var html = '<div class="dl-qv-top"><img class="dl-qv-img" src="'+img+'" alt="'+(product.title||'').replace(/"/g,'&quot;')+'"/><div class="dl-qv-meta">' + (vendor?'<div class="dl-qv-vendor">'+vendor+'</div>':'') + '<h3 class="dl-qv-title">'+(product.title||'')+'</h3><div class="dl-qv-price" data-dl-price>'+formatMoney(initVariant.price)+'</div></div></div>';
    if (hasOptions) {
      html += '<div class="dl-qv-options">';
      for (var k=0; k<product.options.length; k++) {
        var optName = product.options[k];
        html += '<div class="dl-qv-option"><span class="dl-qv-option-label">'+optName+'</span><div class="dl-qv-pills" data-opt-name="'+optName+'" data-opt-index="'+k+'">';
        var seen = {};
        for (var v=0; v<product.variants.length; v++) {
          var val = product.variants[v]['option'+(k+1)];
          if (val == null || seen[val]) continue;
          seen[val] = true;
          var isActive = state.selectedOptions[optName] === val;
          html += '<button type="button" class="dl-qv-pill'+(isActive?' dl-qv-active':'')+'" data-opt-value="'+(val+'').replace(/"/g,'&quot;')+'">'+val+'</button>';
        }
        html += '</div></div>';
      }
      html += '</div>';
    }
    html += '<button type="button" class="dl-qv-cta" data-dl-add>AJOUTER AU PANIER ›</button><div class="dl-qv-msg" data-dl-msg></div>';
    setCardBody(html);
    bindEvents();
    updateCta();
  }

  function bindEvents() {
    var rows = state.card.querySelectorAll('.dl-qv-pills');
    for (var i=0; i<rows.length; i++) rows[i].addEventListener('click', onPill);
    var cta = state.card.querySelector('[data-dl-add]');
    if (cta) cta.addEventListener('click', onAdd);
  }

  function onPill(e) {
    var pill = e.target.closest('.dl-qv-pill');
    if (!pill) return;
    var row = e.currentTarget;
    var name = row.getAttribute('data-opt-name');
    state.selectedOptions[name] = pill.getAttribute('data-opt-value');
    var pills = row.querySelectorAll('.dl-qv-pill');
    for (var i=0; i<pills.length; i++) pills[i].classList.toggle('dl-qv-active', pills[i] === pill);
    syncVariant();
  }

  function syncVariant() {
    var p = state.currentProduct;
    if (!p) return;
    var match = null;
    for (var i=0; i<p.variants.length; i++) {
      var v = p.variants[i], ok = true;
      for (var k=0; k<p.options.length; k++) {
        if (state.selectedOptions[p.options[k]] !== v['option'+(k+1)]) { ok = false; break; }
      }
      if (ok) { match = v; break; }
    }
    state.currentVariant = match;
    var pe = state.card.querySelector('[data-dl-price]');
    if (pe && match) pe.textContent = formatMoney(match.price);
    updateCta();
  }

  function updateCta() {
    var cta = state.card.querySelector('[data-dl-add]');
    if (!cta) return;
    var v = state.currentVariant;
    if (!v || !v.available) { cta.setAttribute('disabled', 'disabled'); cta.textContent = 'INDISPONIBLE'; }
    else { cta.removeAttribute('disabled'); cta.textContent = 'AJOUTER AU PANIER ›'; }
  }

  function setMsg(t, kind) {
    var m = state.card.querySelector('[data-dl-msg]');
    if (!m) return;
    m.textContent = t || '';
    m.className = 'dl-qv-msg' + (kind ? ' ' + kind : '');
  }

  function onAdd() {
    var v = state.currentVariant;
    if (!v || !v.available) return;
    var cta = state.card.querySelector('[data-dl-add]');
    cta.setAttribute('disabled', 'disabled');
    cta.textContent = 'AJOUT…';
    setMsg('', '');
    fetch('/cart/add.js', { method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({id: v.id, quantity: 1, properties: {}}) })
      .then(function(r){ if (!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
      .then(function(){ setMsg('✓ Ajouté au panier', 'ok'); flyToCart(); refreshCount(); setTimeout(closeModal, 1400); })
      .catch(function(e){ err('add failed', e); setMsg('Erreur. Réessayez.', 'err'); cta.removeAttribute('disabled'); cta.textContent = 'AJOUTER AU PANIER ›'; });
  }

  function getCart() {
    var sels = ['.cart-link', '.icon-cart', 'header-cart-bubble', '[data-cart-icon]', '[href$="/cart"]', '[href*="/cart"]'];
    for (var i=0; i<sels.length; i++) { var el = document.querySelector(sels[i]); if (el) return el; }
    return null;
  }

  function flyToCart() {
    var img = state.card.querySelector('.dl-qv-img'), target = getCart();
    if (!img || !target) return;
    var ir = img.getBoundingClientRect(), tr = target.getBoundingClientRect();
    var clone = document.createElement('img');
    clone.src = img.src; clone.className = 'dl-qv-fly';
    clone.style.left = ir.left+'px'; clone.style.top = ir.top+'px';
    clone.style.width = ir.width+'px'; clone.style.height = ir.height+'px';
    document.body.appendChild(clone);
    requestAnimationFrame(function() {
      var dx = (tr.left + tr.width/2) - (ir.left + ir.width/2);
      var dy = (tr.top + tr.height/2) - (ir.top + ir.height/2);
      clone.style.transform = 'translate('+dx+'px,'+dy+'px) scale(.15)';
      clone.style.opacity = '0';
    });
    setTimeout(function(){ if (clone.parentNode) clone.parentNode.removeChild(clone); }, 950);
  }

  function refreshCount() {
    fetch('/cart.js', { credentials:'same-origin' }).then(function(r){ return r.json(); }).then(function(cart) {
      var sels = ['.cart-count', '.cart-link__bubble', '[data-cart-count]', '.icon-cart-count', '.bubble', '.header__cart-count'];
      for (var i=0; i<sels.length; i++) {
        var els = document.querySelectorAll(sels[i]);
        for (var j=0; j<els.length; j++) { els[j].textContent = cart.item_count; els[j].setAttribute('data-count', cart.item_count); }
      }
    }).catch(function(){});
  }

  function openModal(handle) {
    buildModal();
    state.isOpen = true;
    state.backdrop.style.display = 'flex';
    void state.backdrop.offsetWidth;
    state.backdrop.classList.add('dl-qv-open');
    document.body.style.overflow = 'hidden';
    showLoading();
    state.isFetching = true;
    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials:'same-origin', headers:{'Accept':'application/json'} })
      .then(function(r){ if (!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
      .then(function(p){ state.isFetching = false; renderProduct(p); })
      .catch(function(e){ state.isFetching = false; err('fetch failed', e); setCardBody('<div class="dl-qv-loading">Produit indisponible.</div>'); });
  }

  function closeModal() {
    if (!state.modal) return;
    state.backdrop.classList.remove('dl-qv-open');
    document.body.style.overflow = '';
    setTimeout(function(){ if (state.backdrop) state.backdrop.style.display = 'none'; state.isOpen = false; state.currentProduct = null; state.currentVariant = null; }, 260);
  }

  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && state.isOpen) closeModal(); });
  document.addEventListener('mousedown', onIntercept, true);
  document.addEventListener('click', onIntercept, true);
  document.addEventListener('touchstart', onIntercept, true);
  neutralizeSubmit(document);
  try {
    var mo = new MutationObserver(function(muts){
      for (var i=0; i<muts.length; i++) for (var j=0; j<muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n && n.nodeType === 1) neutralizeSubmit(n);
      }
    });
    mo.observe(document.documentElement, { childList:true, subtree:true });
  } catch(e){}
  log('modal ready, listeners registered');
})();
